<div class="home-main-container" [ngClass]="isLoading ? 'home-main-container-loading' : 'home-main-container-loaded'">
  <div class="topnav-container" >
    <app-topnav (loading)="onLoading($event)"></app-topnav>
  </div>
  <div class="main-body-container">
    <router-outlet></router-outlet>
  </div>
</div>
@if (_auth.isLoggingIn) {
  <app-login-load [isHome]="true" [isLoading]="isLoading"></app-login-load>
}@else{
  <app-loader [isLoading]="isLoading"></app-loader>
}
